import { ModuleTemperatureChange, ModuleTemperatureSensorCollection } from "../../Model/Temperature";
export enum ETemperatureAction {
  FETCH_TEMPERATURE_SENSORS_PENDING = "FETCH_TEMPERATURE_SENSORS_PENDING",
  FETCH_TEMPERATURE_SENSORS_SUCCESS = "FETCH_TEMPERATURE_SENSORS_SUCCESS",
  FETCH_TEMPERATURES_SENSORS_ERROR = "FETCH_TEMPERATURES_SENSORS_ERROR",
  UPDATE_TEMPERATURE_READINGS = "UPDATE_TEMPERATURE_READINGS",
}

export interface TemperatureAction {
  type: ETemperatureAction;
  temperatureSensorsCollection?: ModuleTemperatureSensorCollection;
  moduleTemperatureChanges?: ModuleTemperatureChange[];
  error?: any;
}

export function fetchTemperaturePending(): TemperatureAction {
  return {
    type: ETemperatureAction.FETCH_TEMPERATURE_SENSORS_PENDING,
  };
}

export function fetchTemperatureSuccess(
  temperatureSensorsCollection: ModuleTemperatureSensorCollection
): TemperatureAction {
  return {
    type: ETemperatureAction.FETCH_TEMPERATURE_SENSORS_SUCCESS,
    temperatureSensorsCollection: temperatureSensorsCollection,
  };
}

export function fetchTemperatureError(error: any): TemperatureAction {
  return {
    type: ETemperatureAction.FETCH_TEMPERATURES_SENSORS_ERROR,
    error: error,
  };
}

export function updateTemperatureReading(moduleTemperatureChanges: ModuleTemperatureChange[]): TemperatureAction {
  return {
    type: ETemperatureAction.UPDATE_TEMPERATURE_READINGS,
    moduleTemperatureChanges: moduleTemperatureChanges,
  };
}
